const enum ModalComponents {
  AUTH = 'AUTH',
  LOCATION_LOOKUP_FAILED = 'LOCATION_LOOKUP_FAILED',
  LOCATION_SEARCH = 'LOCATION_SEARCH',
  RATINGS_SURVEY = 'RATINGS_SURVEY',
}

export enum AuthModalStates {
  loginSignUp = 'LOGIN_SIGN_UP',
  RESET_PASSWORD = 'RESET_PASSWORD',
}

export default ModalComponents;
